/* eslint-disable */
// AUTO-GENERATED by scripts/generate-antd-compat-icons.mjs — do not edit by hand.
// Regenerate after changing icon-map.txt: `node scripts/generate-antd-compat-icons.mjs`
import { InfoCircleFilled as AntdInfoCircleFilled } from '@ant-design/icons'
import { Info } from 'lucide-react'

import { createIconDispatcher } from '../dispatch'

export default /*#__PURE__*/ createIconDispatcher(
  'info-circle',
  AntdInfoCircleFilled,
  Info,
  'badge'
)
